/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Ask_Meeting_Feedback_TitleInputs */



/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Nudge_Ask_Meeting_Feedback_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_ask_meeting_feedback_title = /** @type {((inputs?: Nudge_Ask_Meeting_Feedback_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Ask_Meeting_Feedback_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Feedback")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour")
	return /** @type {LocalizedString} */ ("Feedback")
});